import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0e5e8e7e")

_pushScopeId("data-v-0e5e8e7e")
const _hoisted_1 = { class: "buy-ticket-box" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "top-item-content" }, " 乘客信息 ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, " ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "top-item-content" }, " 订单支付 ", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, " ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "top-item-content" }, " 完成支付 ", -1)
const _hoisted_8 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_passenger_info = _resolveComponent("passenger-info")
  const _component_pay_order = _resolveComponent("pay-order")
  const _component_complete = _resolveComponent("complete")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["top-item", {active: _ctx.flag1}]
      }, [
        _hoisted_3
      ], 2),
      _hoisted_4,
      _createVNode("div", {
        class: ["top-item", {active: _ctx.flag2}]
      }, [
        _hoisted_5
      ], 2),
      _hoisted_6,
      _createVNode("div", {
        class: ["top-item", {active: _ctx.flag3}]
      }, [
        _hoisted_7
      ], 2)
    ]),
    _createVNode("div", _hoisted_8, [
      (_ctx.status1)
        ? (_openBlock(), _createBlock(_component_passenger_info, {
            key: 0,
            onNext1: _ctx.next1,
            onGetOrder: _ctx.getOrder
          }, null, 8, ["onNext1", "onGetOrder"]))
        : (_ctx.status2)
          ? (_openBlock(), _createBlock(_component_pay_order, {
              key: 1,
              onNext2: _ctx.next2,
              money: _ctx.order.totalPrice,
              order: _ctx.order
            }, null, 8, ["onNext2", "money", "order"]))
          : (_ctx.status3)
            ? (_openBlock(), _createBlock(_component_complete, { key: 2 }))
            : _createCommentVNode("", true)
    ])
  ]))
})